// UpdateList.js

import { Component } from "react";
import { Card, Typography, List, Divider, Badge, Tag, Alert } from "antd"; // นำเข้า Badge จาก antd
import { updatesData } from "../Data/updatesData";
import PageHeader from "../components/PageHeader";
import { removeSlashesFromPath } from "../helpers/location/removeSlashesFromPath";
import config from "../config/app.config";

const { Text } = Typography;

class UpdateList extends Component {
  render() {
    // กรองและเรียงลำดับข้อมูล updates จากเวอร์ชันล่าสุดไปเก่าสุด
    const sortedUpdates = (updatesData || [])
      .slice()
      .sort((a, b) => b.version.localeCompare(a.version));

    // ตรวจสอบว่ามีข้อมูล updates หรือไม่
    if (!sortedUpdates || sortedUpdates.length === 0) {
      return (
        <Card title="รายการอัปเดต">
          <p>ยังไม่มีรายการอัปเดต</p>
        </Card>
      );
    }

    return (
      <div style={{ flex: 1 }}>
        <div className="container-fluid">
          <PageHeader
            HeaderText={"รายการอัปเดต"}
            Breadcrumb={[
              {
                name: removeSlashesFromPath(window.location.pathname),
                navigate: window.location.pathname,
              },
            ]}
          />
          <br/>
          <Alert type="info" showIcon message={`หากยังไม่เป็น Version ล่าสุด ให้กด 'Ctrl + F5'`} />
          <br/>
          <Badge.Ribbon
            text={config?.version}
            color="#108ee9"
            style={{ display: "" }} // ซ่อน Ribbon
          >
            <Card title={<h5>รายการอัปเดต</h5>}>
              <List
                className="p-3"
                itemLayout="vertical"
                dataSource={sortedUpdates}
                renderItem={(update, index) => {
                  // ตรวจสอบว่าเป็นเวอร์ชันล่าสุดหรือไม่
                  const isLatestVersion = config?.version === update?.version;

                  return (
                    <div key={update?.version}>
                      <div style={{ marginBottom: "8px" }}>
                        <Text strong className="mb-3">
                          {isLatestVersion ? (
                            <>
                              เวอร์ชัน: {update?.version}{" "}
                              <Tag
                                id="tagsStatus"
                                color="#f50"
                                style={{ fontSize: "10px" }}
                              >
                                New
                              </Tag>
                            </>
                          ) : (
                            <Text delete>{`เวอร์ชัน: ${update?.version}`}</Text>
                          )}
                        </Text>
                        <br />
                        <Text type="secondary mt-3">
                          วันที่อัปเดต: {update?.date}
                        </Text>
                      </div>

                      <Text strong>รายละเอียดที่อัปเดต:</Text>
                      <List
                        size="small"
                        dataSource={update?.details}
                        renderItem={(detail, detailIndex) => (
                          <List.Item
                            style={{
                              borderBlockEnd: "1px solid #05050500",
                            }}
                          >
                            {`${detailIndex + 1}. ${detail}`}
                          </List.Item>
                        )}
                        style={{ marginLeft: "20px" }}
                      />
                      {index < sortedUpdates.length - 1 && <Divider />}
                    </div>
                  );
                }}
              />
              
              <p className="text-center" style={{ color: "#888" }}>
                Version: {config?.version}
              </p>
            </Card>
          </Badge.Ribbon>
        </div>
      </div>
    );
  }
}

export default UpdateList;
